import styled from "@emotion/styled";

export const Root = styled("div")({
    display: "flex",
    flexDirection: "column",
    height: "100%",
});

export const ResultContainer = styled.div(_ => ({
    flex: "1 1 100%",
    textAlign: "center",
    padding: "0 20px",
}));

export const CenterContentInBlock = styled("div")({
    textAlign: "center",
});

export const Footer = styled("div")<{ hasCloseButton: boolean }>(props => ({
    position: "absolute",
    zIndex: 10,
    bottom: 0,
    width: "100%",
    height: props.hasCloseButton ? 165 : 115,
}));

export const ActionButtonsContainer = styled("div")({
    padding: "0 20px 15px",
});
